<template>
    <v-card class="kim-card pa-2">

        <v-card-text>
            <v-layout wrap>
                <v-flex xs12 text-center>
                    <v-progress-linear v-if="loading" indeterminate height="2" />
                </v-flex>
            </v-layout>
            <v-slide-y-transition>

              <template v-show="!loading">

                <v-card flat>
                  <v-tabs
                      center-active
                  >
                    <v-tab
                        active-class="active-tab"
                        v-for="(category,i) in history"
                        :key="`ep-${i}`">
                      {{category.description}}
                      <v-badge color="secondary" :content="`${category.items.length}`" offset-x="1" />
                    </v-tab>

                    <v-tab-item
                        v-for="(category,i) in history"
                        :key="`ep-content-${i}`"
                    >

                      <v-card flat color="secondary-card">
                        <v-card-text>

                          <v-sheet
                              v-if="allowAdd">
                            <history-item-picker
                                label="Agregar ítem"
                                :medical-history-category-id="category.id"
                                auto-attach
                                :event-id="eventId"
                                @change="onHistoryItemSelect"
                            />
                          </v-sheet>

                          <div v-if="category.items.length === 0" class="py-3">
                            <div class="caption">Sin antecedentes</div>
                          </div>

                          <v-simple-table dense v-else>
                            <template v-slot:default>
                              <thead>
                              <tr>
                                <th scope="col" width="40px" class="text-left"></th>
                                <th scope="col" class="text-left">Descripción</th>
                                <th scope="col" class="text-center">Eliminar</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr
                                  v-for="(item, i) in category.items"
                                  :key="`hi-${i}`">
                                <td>{{i+1}}</td>
                                <td class="text-left">{{item.description}}</td>
                                <td class="text-center">
                                  <v-icon
                                      v-if="item.pivot.schedule_event_id === eventId && item.pivot.schedule_event.event_status_id === 4"
                                      absolute right color="accent" @click="deleteItem(item)">delete</v-icon>
                                </td>
                              </tr>
                              </tbody>
                            </template>
                          </v-simple-table>

                        </v-card-text>
                      </v-card>

                    </v-tab-item>

                  </v-tabs>
                </v-card>

              </template>
            </v-slide-y-transition>
        </v-card-text>
        <kimsa-confirm
                ref="deleteModal"
                title="Eliminar antecedente"
                content="¿Está seguro que desea eliminar este item?"
                :loading="loadingDelete"
                :persistent="false"
                @confirm="deleteItemConfirm"
                :close-on-confirm="false"
        ></kimsa-confirm>
    </v-card>
</template>

<script>
    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import HistoryItemPicker from './HistoryItemPicker'

    import {uuid} from '@/utils/Common'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'

    export default{
          components: {KimsaConfirm, HistoryItemPicker},
        props: ['clientId', 'eventId', 'allowAdd', 'defaultHistory'],
        data(vm){
            return {
                loading: false,
                loadingAttach: false,
                loadingDelete: false,
                itemToDelete: null,
                history: vm.defaultHistory || null
            }
        },

        mounted(){
            if(!this.defaultHistory) this.getHistory()
        },

        computed: {
                ...mapState(['currentProvider'])
        },

        methods: {
                ...mapMutations(['showSnackBar']),
            uuid,
            async onHistoryItemSelect(item){

                if(!item) return
                var vm = this

                vm.loadingAttach = true
                const response = await ApiUtils.makePost('history/item/attach', {
                    schedule_event_id: vm.eventId,
                    medical_history_item_id: item.id
                })
                vm.loadingAttach = false

                if(response.ok){
                    const json = await response.json()
                    const attachedItem = json.result.item
                    vm.$emit('attach', attachedItem)
                }
            },
            deleteItem(item){
                var vm = this
                vm.itemToDelete = item
                vm.$refs.deleteModal.show()

            },
            async deleteItemConfirm(){
                var vm = this

                if(vm.loadingDelete) return

                if(!vm.itemToDelete) {
                    throw new Error('Item to delete not set')
                }

                vm.loadingDelete = true
                const response = await ApiUtils.makePost(`history/item/detach`, {
                    medical_history_item_id: vm.itemToDelete.pivot.medical_history_item_id,
                    schedule_event_id: vm.itemToDelete.pivot.schedule_event_id,
                })
                vm.loadingDelete = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando eliminar el item')
                    return
                }

                vm.$emit('detach', {
                    id: vm.itemToDelete.id,
                    medical_history_category_id: vm.itemToDelete.medical_history_category_id
                })

                vm.itemToDelete = null
                vm.$refs.deleteModal.hide()
            },
            async getHistory(silent = false){

                var vm = this

                if(vm.loading || !vm.currentProvider) return

                if(!silent){
                    vm.loading = true
                }

                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/client/${vm.clientId}/history`)
                vm.loading =false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intenando cargar la historia clinica')
                    return
                }

                const json = await response.json()
                vm.history  = json.result.history

            }
        },

        watch: {
            clientId(val){
                if(val){
                    if(!this.defaultHistory)this.getHistory()
                }
            }
        }
    }
</script>


<style scoped>

  .active-tab {
    background-color: var(--v-secondary-card-base) !important;
    border-radius: 10px 10px 0 0;
  }

  >>>.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
    visibility: hidden;
  }

    >>>.v-tabs:not(.v-tabs--vertical) .v-tab{
      text-transform: none !important;
      padding: 1px 30px;
    }

    .history-item{
        border-radius: 5px;
        transition: all .3s
    }

    .history-item:hover{
        background-color: rgba(0,0,0,.05);
    }

    >>>.v-expansion-panel__container--active .v-expansion-panel__header{
        font-weight: bold;
       }

    >>>.v-badge__badge{
        font-size: 12px;
        top: -12px;
        right: -24px;
        border-radius: 50%;
        height: 20px;
        width: 20px;
    }
</style>
